import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { handleResponse } from 'src/functions/http-handler';
import { IPagedList } from 'src/models/paged-list.model';

@Injectable({
  providedIn: 'root'
})
export class UserAuthService {
  private _apiUrl: string;

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private logger: NGXLogger) {
    this._apiUrl = `${baseUrl}api/UserAuth`;
  }

  get(codes: Array<string>, userIds: Array<string>, pageNum: number, pageSize: number) {
    const param = { vendorCodes: codes, userIds: userIds, pageNum: pageNum.toString(), pageSize: pageSize.toString() };
    return this.http.get(this._apiUrl, { params: param })
      .pipe(handleResponse<IPagedList<IUserAuth>>(this.logger, 'retrieve user auth'));
  }

  upsert(auth: IUserAuth) {
    const param = { Id: auth.id, programID: auth.programID };
    return this.http.put(this._apiUrl, auth, { params: param })
      .pipe(handleResponse<IUserAuth>(this.logger, 'upsert user auth'));
  }
}

export interface IUserAuth {
  id: string,
  accountNum: string,
  programID: string,
  canWrite: boolean,
  canRead: boolean,
  canPrint: boolean,
}

